/*
barba.init({

  }); 

  */

/*
  barba.init({

    transitions: [{
        name: 'opacity-transition',
        leave(data) {
          return gsap.to(data.current.container.children.page_transition_element, {
            width:'100%'
          });
        },
        enter(data) {
          return gsap.from(data.next.container.children.page_transition_element, {
            width: '100%'
          });
        }
      }] 

      
});


  

barba.hooks.afterEnter((data) => {
  pageLoadFunctions();
});

*/